module.exports = __webpack_public_path__ + "img/vehicle_back.3df5a3fd.png";